import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'
import './heading-baseline.css'
import './override.css'

function CssBaseline() {
  return null
}

export default CssBaseline
